<table mat-table [dataSource]="calls" class="full-width">
  <ng-container matColumnDef="number">
    <th mat-header-cell *matHeaderCellDef> Numero </th>
    <td mat-cell *matCellDef="let call" class="title">
      <a class="call-link" routerLinkActive="actived" [routerLink]="'/operador/chamados/' + call.identifier">
        #{{call.number}}
      </a>
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let call">
      <mat-chip-list aria-label="Fish selection">
        <mat-chip [class]="classesByState(call)">
          <small>
            {{call.status_detail.text.toUpperCase()}}
          </small>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>
  <ng-container matColumnDef="business">
    <th mat-header-cell *matHeaderCellDef> Empresa </th>
    <td mat-cell *matCellDef="let call"> 
      {{call.business != null ? call.business.name : "EMPRESA NÃO DEFINIDA"}} 
    </td>
  </ng-container>

  <ng-container matColumnDef="business_user">
    <th mat-header-cell *matHeaderCellDef> Solicitante </th>
    <td mat-cell *matCellDef="let call">
      {{call.business_user != null ? getShowName(call.business_user.name) : "SOLICITANTE NÃO DEFINIDA"}}
    </td>
  </ng-container>

  <ng-container matColumnDef="open_since">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let call">
      <b>{{call.open_since}}</b> 
    </td>
  </ng-container>

  <ng-container matColumnDef="user">
    <th mat-header-cell *matHeaderCellDef> Responsável </th>
    <td mat-cell *matCellDef="let call"> {{call.user != null ? getShowName(call.user.name) : ""}} </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef> Tipo </th>
    <td mat-cell *matCellDef="let call"> {{call.type_detail.text}} </td>
  </ng-container>

  <ng-container matColumnDef="priority">
    <th mat-header-cell *matHeaderCellDef> Prioridade </th>
    <td mat-cell *matCellDef="let call"> {{call.priority_detail.text}} </td>
  </ng-container>

  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let call" style="text-align: right;">
      <a
        mat-icon-button
        color="link"
        href="/operador/chamados/{{call.identifier}}"
      ><mat-icon>launch</mat-icon></a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
